import axios from "axios";
export const HEIGHT = 92;
export const normalizeString = (str) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u");








export const chars = {
  ü: "u",
  Ü: "U",
  ğ: "g",
  Ğ: "G",
  ı: "i",
  İ: "I",
  ş: "s",
  Ş: "S",
  ç: "c",
  Ç: "C",
  ö: "o",
  ë: "e",
  č: "c",
  ć: "c",
  ž: "z",
  š: "s",
};

const charsSame = {
  ü: "ü",
  Ü: "Ü",
  ğ: "ğ",
  Ğ: "Ğ",
  ı: "ı",
  İ: "İ",
  ş: "ş",
  Ş: "Ş",
  ç: "ç",
  Ç: "Ç",
  ö: "ö",
  ë: "ë",
  č: "č",
  ć: "ć",
  ž: "ž",
  š: "š",
};
export const regexString = /[üÜğĞıİşŞçÇöëčćžš]/g;
export const GOOGLE_KEY = "AIzaSyD43kaQ1qZFKWw9VMX5YzH2EEEGePZWNT0";
export const googleMapURL = `https://maps.google.com/maps/api/js?key=${GOOGLE_KEY}&sensor=true`;


class Utils {

  static getUserToken() {
    const token = localStorage.getItem("jwt");
    const data =
      token !== null
        ? {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
        : {};
    axios.defaults.withCredentials = true;
    return data;
  }

  static formatirajBroj(broj, decimal = 2) {
    if (broj !== null && broj !== undefined) {
      return parseFloat(broj)
        ?.toFixed(decimal)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      // .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return 0;
    }
  }
}

export default Utils;

// export const gridOptions = {
//   // ...
//   // enableCellTextSelection: true,
//   rowGroupPanelShow: "always", //'never', 'always', 'onlyWhenGrouping'
//   pivotPanelShow: "always", //'never', 'always', 'onlyWhenPivoting'
//   groupDisplayType: "groupRows",
//   groupRowRendererParams: Utils.groupRowRendererParams(),
//   colResizeDefault: "shift",
//   animateRows: true,
//   includeHiddenColumnsInQuickFilter: true,
//   includeHiddenColumnsInAdvancedFilter: true,
//   suppressRowClickSelection: true,
//   groupIncludeTotalFooter: false,
//   suppressAggFuncInHeader: true,
//   cacheQuickFilter: true,
//   getRowStyle: (params) => {
//     // Vrati stil crvene boje ako je deleted_at različit od null

//     if (params.node.group) return { backgroundColor: "#eee", color: "black" };

//     // Inače vrati prazan objekat (nema dodatnih stilova)
//     return {};
//   },
//   columnTypes: {
//     checkbox: {
//       // Konfiguracija tipa kolone 'checkbox' ide ovde
//       // headerCheckboxSelection: true, // Na primer, ovo omogućava selekciju u zaglavlju
//     },
//     text: {},
//     select: {},
//     date: {},
//   },
//   // ...
// };

export const havePermLocal = (requiredPermissions, userRoles) => {
  if (!userRoles || !requiredPermissions?.length) return false;

  const rolesArray = userRoles
    .toString()
    .split(",")
    .map((r) => r.trim());

  const perms = requiredPermissions.map((p) => p.toString().trim());

  return rolesArray.some((role) => perms.includes(role));
};
